import
{
    useL10n
} from "@ews/react-localization-context";

import
{
    IonItem,
    IonModal,
    IonPopover,
    IonTitle
} from "@ionic/react";

import
{
    Responsive,
    useIsMobile
} from "../../Responsive";

import
{
    LicenseType,
    permissionAllowed,
    SystemStatus,
    SystemType
} from "@ews/react-data";

import React, {
    ReactNode,
    useRef,
    useState
} from "react";

import
{
    firstLetterUpperCase
} from "../GroupOverview/helper";

import GruppList from "../GruppList/GruppList";
import styleGroup from './GroupItem.module.scss';

import Icon, { IconName } from "@ews/react-icons";

import
{
    providesMeasurements as _providesMeasurements,
    AuthorizationLevel,
    eventDetails,
    eventGetSymbol,
    eventRTMCategory,
    formatLogicalAddress,
    NoDeviceNumber,
    NumberGroup,
    RTMCategory
} from "@ews/zlt-events";

import { PositionSide } from "../../List/types";

import Operate, {
    getAddress,
    OperateSidebarProps,
    SelectRange, validOperations
} from "../../Navigation/Sidebar/Operate";

import
{
    ReactClickEvent
} from "../../types";

import
{
    Col
} from "../GruppList/components/Col";

import
{
    MenuComponent
} from "../GruppList/components/Menu";

import
{
    useAuthorization
} from "../../Authorization";

import
{
    useSystemStatus
} from "../../System/SystemStatus";

import
{
    SystemElement,
    SystemGroup,
    useCurrentSystem
} from "../../ReactData/system";

import { useHasLicense } from "../../HasLicense";
import { useNamedRoutes } from "../../NamedRoutes";
import { MenuLinkProps } from "../../Navigation/Sidebar/Sidebar";
import listStyle from "../GruppList/GruppList.module.scss";
import { useMyPermissions } from "../../Login/LoginProvider";

type EventItemProps = {
    groups: SystemGroup[];
    title: string;
    className?: string;
};

function maxScreenHeight(height: number, y: number, side: PositionSide, margin: number = 10): number
{
    return (side === "bottom" ? (height - y) : y) - margin;
}

function pxToPercent(childSize: number, parentSize: number): number
{
    return Math.round((childSize / parentSize) * 100);
}

const providesMeasurements = (target: SystemGroup | SystemElement) =>
{
    if ("elements" in target) {
        return Boolean(target.elements?.filter(e => _providesMeasurements(e.additionalParameters.AddrType || 'Unknown')).length);
    }
    return _providesMeasurements(target.additionalParameters.AddrType || 'Unknown');
};

const GroupItem: React.FC<EventItemProps> = ({
    groups,
    title,
    className,
}) =>
{
    const mobileView = useIsMobile();
    const permissions = useMyPermissions();
    const { authorizationLevel } = useAuthorization();
    const system = useCurrentSystem();

    const hasOperationAndPushLicense = useHasLicense(LicenseType.OPERATE_AND_NOTIFICATION);
    const hasPlanLicense = useHasLicense(LicenseType.PLAN_VIEW);

    function isOnPlanView(target: SystemGroup | SystemElement, hasPlanLicense: boolean)
    {
        const onPlan = (element: SystemElement | undefined, systemPlanId: string | undefined) => Boolean(element && systemPlanId && hasPlanLicense);

        if ("elements" in target) {
            const group = target as SystemGroup;
            const value = (group.elements?.filter(element => onPlan(element, element?.systemPlanId)).length || 0) > 0;
            return value;
        } else {
            const element = target as SystemElement;
            const value = onPlan(element, element.systemPlanId);
            return value;
        }
    };

    function getPlanLink(target: SystemGroup | SystemElement): MenuLinkProps | undefined 
    {

        if ("elements" in target) {
            const elementsOnPlan = (target.elements || []).filter(element => element.systemPlanId && element.systemPlanX && element.systemPlanY);
            if (elementsOnPlan.length > 0) {
                const planId = elementsOnPlan[0].systemPlanId;
                return {
                    title: t('[REACT_REDIRECT_PLAN]'),
                    link: generate("system:plan", { id: target.systemId!, planId }),
                    icon: <Icon icon="plan" />
                };
            }
        }
        else if ("id" in target && "groupId" in target) {

            const planId = target.systemPlanId;
            return {
                title: t('[REACT_REDIRECT_PLAN]'),
                link: generate("system:plan", { id: target.systemId!, planId }),
                icon: <Icon icon="plan" />
            };
        }
        else {
            return {
                title: t('[REACT_REDIRECT_PLAN]'),
                link: generate("system:plan", { id: target.systemId! }),
                icon: <Icon icon="plan" />
            };
        }

    };


    const systemStatus = useSystemStatus(system.id || "");
    const { generate } = useNamedRoutes();
    const { translate: t } = useL10n();

    const [range, setRange] = useState<SelectRange>({});

    const ContextMenuElement = mobileView ? IonModal : IonPopover;

    const [ContextMenu, setContextMenu] = useState<{ contextMenu?: ReactNode, event?: ReactClickEvent; }>({});
    const contextDirection = useRef<PositionSide>("bottom");
    const contextMaxHeight = useRef<number | null>(1050);

    const isBC216 = system.systemType === SystemType.BC216;

    const rangeSelect = (target: SystemGroup | SystemElement) =>
    {

        let hideMenu = false;


        if (!range.begin) {
            hideMenu = true;
            range.begin = target;
        } else {
            range.end = target;
        }

        setRange(range);
        if (hideMenu) dismissOptions();


        return range;

    };

    const presentOptions = (target: SystemGroup | SystemElement, hasOperations: boolean, hasPlanLicense: boolean = false, e?: ReactClickEvent) =>
    {

        const isOnPlan = isOnPlanView(target, hasPlanLicense); //(target as SystemElement).systemPlanId;
        const customLinks: OperateSidebarProps["customLinks"] = [];

        if (isOnPlan) {
            const link = getPlanLink(target);
            if (link) {
                customLinks.push(link);
            }
        }

        if (permissionAllowed(permissions.permitAccessLevel3!) && providesMeasurements(target)) {
            console.log(target);
            const query: {
                id?: string;
                numberGroup?: string,
                group?: string,
                element?: string;
            } = {
                numberGroup: `${target.numberGroup}`,
                id: target.systemId,
            };

            if (!("elements" in target)) {
                query.element = `${target.id}`;
                query.group = `${(target as SystemElement).groupId}`;


            } else {
                query.group = `${(target as SystemGroup).id}`;

            }
            customLinks.push({
                title: `${t("COM_FACPMANAGEMENT_FACP_FIELD_MEASUREMENT_BUTTON")}`,
                link: generate("system:analoguevalues", query),
                icon: <Icon icon="event_memory" />
            });
        }

        if (range.end) {
            delete (range.end);
            delete (range.begin);
            setRange({});
        }

        const contextMenu = <Operate
            target={target}
            range={(hasOperations && !isBC216) ? range : undefined}
            onRangeSelect={rangeSelect}
            onMenuToggle={dismissOptions}
            customLinks={customLinks}
            onlyOriginalEvents={isBC216 && "elements" in target}
        />;


        const { clientY, view } = e!.nativeEvent as PointerEvent;
        const screenHeight = view?.innerHeight || 0;
        const heightPercent = pxToPercent(clientY, screenHeight);
        const side = heightPercent >= 70 ? "top" : "bottom";

        if (e?.cancelable) e?.preventDefault();
        setContextMenu({ contextMenu, event: e });

        contextDirection.current = side as PositionSide;
        contextMaxHeight.current = maxScreenHeight(screenHeight, clientY, side as PositionSide);
    };

    const dismissOptions = () =>
    {
        setContextMenu({});
    };

    const getEventIcon = (target: SystemGroup | SystemElement, group: SystemGroup): IconName =>
    {
        const address = getAddress(target);
        const { eventKindType } = target;
        const { rtm } = eventDetails(eventKindType!) || {};

        try {

            if ("elements" in target && rtm === RTMCategory.TestCondition) {
                const testRTM = target.rtm?.filter(e => e.eventKindType === eventKindType).pop();
                if (testRTM?.errorCode === -1) return "Test_alarm_L_red";
            } else if (eventRTMCategory(group.eventKindType || 0) === RTMCategory.TestCondition) {
                const testRTM = group.rtm?.filter(e => e.eventKindType === group.eventKindType).pop();
                if (testRTM?.timestamp! < (target as SystemElement).latestTestAlarm) return "Test_alarm_L_red";
            }

            return eventGetSymbol(eventKindType!, address);

        } catch (e) {

            return "none";
        };
    };

    return <section className={`${className} ${listStyle.rowContainer}`}>
        <IonItem
            lines="full"
            color={mobileView ? undefined : 'medium'}
        >
            <IonTitle
                className={styleGroup.title}
            >
                {t(firstLetterUpperCase(title))}
            </IonTitle>

        </IonItem>

        <ContextMenuElement
            reference="event"
            side={contextDirection.current}
            event={ContextMenu.event?.nativeEvent}
            initialBreakpoint={mobileView ? .6 : undefined}
            // className={mobileView ? listStyle.menu : ''}
            isOpen={Boolean(ContextMenu.contextMenu)}
            onDidDismiss={dismissOptions}
            keepContentsMounted={true}
            style={{ alignItems: "start", "--max-height": `${contextMaxHeight.current}px `, }}
        >
            {ContextMenu.contextMenu}
        </ContextMenuElement>

        < GruppList
            rows={groups}
            //maxHeight={mobileView ? "83vh" : "49vh"} // mobile mit header "83.5vh"
            onMenu={(group, element, e) =>
            {

                const hasOperations = Boolean(validOperations(authorizationLevel, element || group, undefined, isBC216 && !Boolean(element)).length && hasOperationAndPushLicense);
                const isOnPlan = isOnPlanView(element ? element : group, hasPlanLicense);
                const hasMeasurements = permissionAllowed(permissions.permitAccessLevel3!) && providesMeasurements(element || group);

                if (hasMeasurements || isOnPlan || hasOperations) presentOptions(element || group, hasOperations, hasPlanLicense, e);
            }}
            headers={
                [
                    {
                        title: () => <div className={`${listStyle.settingsIcon}`}></div>,
                        render: (group, element) =>
                        {
                            const isOnPlan = isOnPlanView(element ? element : group, hasPlanLicense);
                            const hasOperations = Boolean(group.operate && validOperations(authorizationLevel, element || group, undefined, isBC216 && !Boolean(element)).length && hasOperationAndPushLicense);
                            const hasMeasurements = permissionAllowed(permissions.permitAccessLevel3!) && providesMeasurements(element || group);

                            return <Responsive desktop>
                                {(hasMeasurements || isOnPlan || hasOperations) ?
                                    <MenuComponent onClick={(e) => presentOptions(element || group, hasOperations, hasPlanLicense, e)} />
                                    : <div className={`${listStyle.settingsIcon}`}></div>}
                            </Responsive>;
                        }
                    },
                    {
                        title: () => <Col className={`${listStyle.status}`}>{t('[SID_MNU_TAB_STATUS]')}</Col>,
                        render: (group, element) => (
                            <div className={`${listStyle.status}`}>
                                <Icon icon={getEventIcon(element || group, group)} />
                            </div>
                        )
                    },
                    // {
                    //     title: () => <></>,
                    //     render: (group, element) => (
                    //         <RangeBox data-testId="rangebox"
                    //             onChange={(checked) => console.log()}
                    //             checked={false} />
                    //     )
                    // },
                    {
                        title: () => (
                            <Col className={`${listStyle.number}`}>{t('TD_NUMMER_FWI_INP')}</Col>
                        ),
                        render: (group, element) => (
                            <Col className={`${listStyle.number}`}>{formatLogicalAddress(group.id!, element?.id || NoDeviceNumber, group.numberGroup || NumberGroup.Zone)}</Col>
                        )
                    },
                    {
                        title: () => <Col>{t('[SID_DLG_TXT_TEXT1]')}</Col>,
                        render: (group, element) => (
                            <Col>
                                <Responsive mobile>{(element || group).text}</Responsive>
                                <Responsive desktop>{group.text}</Responsive>
                            </Col>
                        )
                    },
                    {
                        title: () => (
                            <Col>{t('TD_ELEMENTTEXT')}</Col>
                        ),
                        render: (group, element) => (
                            <Responsive desktop>
                                <Col>{element?.text}</Col>
                            </Responsive>
                        )
                    },
                    {
                        title: () => <div className={`${listStyle.settingsIcon}`}></div>,
                        render: (group, element) =>
                        {

                            const isOnPlanView = Boolean(element && element.systemPlanId && hasPlanLicense);
                            const hasOperations = Boolean(group.operate && validOperations(authorizationLevel, element || group).length && hasOperationAndPushLicense);

                            return <Responsive mobile>
                                {((hasOperations && systemStatus === SystemStatus.ONLINE) || (isOnPlanView && hasPlanLicense)) ?
                                    <MenuComponent onClick={(e) => presentOptions(element || group, hasOperations, hasPlanLicense, e)} />
                                    : <div className={`${listStyle.settingsIcon}`}></div>}
                            </Responsive>;
                        }
                    },

                ]}
        />
    </section>;

};

export default GroupItem;
